
import firebase from "./initFirebase";

export const userRef = firebase.database().ref('User');
export const goalRef = firebase.database().ref('Goal');
export const taskRef = firebase.database().ref('Task');
